export default "__VITE_ASSET__DsXSdceC__"